export const Progress = ({ value, className, ...props }) => {
  return (
    <div className={`relative h-2 w-full overflow-hidden rounded-full bg-muted ${className}`} {...props}>
      <div
        className="h-full bg-primary transition-all duration-300 ease-in-out"
        style={{ width: `${value}%` }}
      />
    </div>
  );
};
